module.exports = __webpack_public_path__ + "img/13-1.f927a527.png";